import React, {useEffect,useState } from 'react'; 
import Header from "../Component/Header";
import { Link } from 'react-router-dom' 
import { form1 } from "../Service/Api";
import { getHeader } from "../config"
const Alumni = () => {
    useEffect(() => {
        document.title = 'Alumni -  The Air Force School Subroto Park';  
    }, []);  
    const [successMessage, setSuccessMessage] = useState("");
    const [formData, setFormData] = useState({
        name :"",
        address :"",
        class :"",
        toYear :"",
        email :"",
        profession1:"",
        location:"",
        phone :"",
        school:"",
        profession3:"",
        fromYear:"",
        subject:"",
        school1:"",
        designation:"",
        address1:"",
       
    });
    const [errors, setErrors] = useState({});

    const handleChange = (e) => { 
            setFormData({
                ...formData,
                [e.target.name]: e.target.value
            });
            setErrors({ ...errors, [e.target.name]: "" }); // Clear the error for the field being changed
        
    };

    const validateForm = () => {
        const newErrors = {};
      const hasSpecialChars = str => /[!@#$%^&*()_+=,.?":{}|<>]/g.test(str); 
      const hasNumbersOnly = str => /^\d+$/.test(str);
const isValidEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
const isValidPhone = phone => /^\d{10}$/.test(phone); // Adjust for your format

if (!formData.name || formData.name.trim() === "") {
  newErrors.name = "Name is required.";
} else if (hasSpecialChars(formData.name)) {
  newErrors.name = "Name should not contain special characters.";
}

if (!formData.address || formData.address.trim() === "") {
  newErrors.address = "Address is required.";
}

if (!formData.class || formData.class.trim() === "") {
  newErrors.class = "Last Class is required.";
}

if (!formData.toYear || formData.toYear.trim() === "") {
  newErrors.toYear = "Batch is required.";
} 

if (!formData.email || formData.email.trim() === "") {
  newErrors.email = "Email is required.";
} else if (!isValidEmail(formData.email)) {
  newErrors.email = "Email format is invalid.";
}
if (!formData.profession1 || formData.profession1.trim() === "") {
    newErrors.profession1 = "Profession is required.";
    } 
 
if (!formData.location || formData.location.trim() === "") {
    newErrors.location = "Location is required.";
  } else if (hasSpecialChars(formData.location)) {
    newErrors.location = "Location should not contain special characters.";
  }
if (!formData.school || formData.school.trim() === "") {
    newErrors.school = "College is required.";
  } else if (hasSpecialChars(formData.school)) {
    newErrors.school = "College should not contain special characters.";
  }
  
  if (!formData.profession3 || formData.profession3.trim() === "") {
    newErrors.profession3 = "Degre is required.";
  } else if (hasSpecialChars(formData.profession3)) {
    newErrors.profession3 = "Degre should not contain special characters.";
  }
  
  if (!formData.subject || formData.subject.trim() === "") {
    newErrors.subject = "Stream is required.";
  } else if (hasSpecialChars(formData.subject)) {
    newErrors.subject = "Stream should not contain special characters.";
  }
  
  if (!formData.school1 || formData.school1.trim() === "") {
    newErrors.school1 = "Organisation Name is required.";
  } else if (hasSpecialChars(formData.school1)) {
    newErrors.school1 = "Organisation Name should not contain special characters.";
  }
  if (!formData.fromYear || formData.fromYear.trim() === "") {
    newErrors.fromYear = "Sem / Year is required.";
  } else if (!hasNumbersOnly(formData.fromYear)) {
    newErrors.fromYear = "Sem / Year should not contain special characters.";
  }
  if (!formData.designation || formData.designation.trim() === "") {
    newErrors.designation = "Designation is required.";
  } else if (hasSpecialChars(formData.designation)) {
    newErrors.designation = "Designation should not contain special characters.";
  }
  
  if (!formData.address1 || formData.address1.trim() === "") {
    newErrors.address1 = "Office Address is required.";
  } else if (hasSpecialChars(formData.address1)) {
    newErrors.address1 = "Office Address should not contain special characters.";
  }
   
if (!formData.phone || formData.phone.trim() === "") {
  newErrors.phone = "Mobile is required.";
} else if (!isValidPhone(formData.phone)) {
  newErrors.phone = "Phone number should be 10 digits.";
}
       
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const type = 'XYZ'; 
        console.log('Submitting form with type:', type); // Debugging line
 
        try {
            const { header } = getHeader(); // Make sure this function returns the correct headers
            const response = await form1(formData, header, type); 
            console.log('Form submitted successfully', response);
            setSuccessMessage("Your Form Submitted Successfully.");
            setFormData({
                name :"",
                address :"",
                class :"",
                toYear :"",
                email :"",
                profession1:"",
                location:"",
                phone :"",
                school:"",
                profession3:"",
                fromYear:"",
                subject:"",
                school1:"",
                designation:"",
                address1:"",
            });
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };
 
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> Alumni Form  </li> 
                  
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Alumni  Form</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                    <form onSubmit={handleSubmit}>
                    <div className="mainform">
                       <h6>Kindly select the batch/session and class you last attended at school</h6>
                       <div className="row">
                         <div className="col-lg-6">
                                <div className="form-group">
                                <label className="form-label"> Batch <span>*</span></label> 
                                <select className="form-control" name="toYear" value={formData.toYear} onChange={handleChange}> 
                                        <option value="">- Select -</option><option value="2023-2024">2023-2024</option>
                                        <option value="2022-2023">2022-2023</option>
                                        <option value="2021-2022">2021-2022</option>
                                        <option value="2020-2021">2020-2021</option>
                                        <option value="2019-2020">2019-2020</option>
                                        <option value="2018-2019">2018-2019</option><option value="2017-2018">2017-2018</option> <option value="2016-2017">2016-2017</option> <option value="2015-2016">2015-2016</option> <option value="2014-2015">2014-2015</option> <option value="2013-2014">2013-2014</option> <option value="2012-2013">2012-2013</option> <option value="2011-2012">2011-2012</option> <option value="2010-2011">2010-2011</option> <option value="2009-2010">2009-2010</option> <option value="2008-2009">2008-2009</option> <option value="2007-2008">2007-2008</option> <option value="2006-2007">2006-2007</option> <option value="2005-2006<">2005-2006</option> <option value="2004-2005">2004-2005</option> <option value="2003-2004">2003-2004</option> <option value="2002-2003">2002-2003</option> <option value="2001-2002">2001-2002</option> <option value="2000-2001">2000-2001</option> <option value="1999-2000">1999-2000</option> <option value="1998-1999">1998-1999</option> <option value="1997-1998">1997-1998</option> <option value="1996-1997">1996-1997</option> <option value="1995-1996">1995-1996</option> <option value="1994-1995">1994-1995</option> <option value="1993-1994">1993-1994</option> <option value="1992-1993">1992-1993</option> <option value="1991-1992">1991-1992</option> <option value="1990-1991">1990-1991</option> <option value="1889-1990">1889-1990</option> <option value="1988-1989">1988-1989</option> <option value="1987-1988">1987-1988</option> <option value="1986-1987">1986-1987</option> <option value="1985-1986">1985-1986</option> <option value="1984-1985">1984-1985</option> <option value="1983-1984">1983-1984</option> <option value="1982-1983">1982-1983</option> <option value="1981-1982">1981-1982</option> <option value="1980-1981">1980-1981</option> <option value="1979-1980">1979-1980</option> <option value="1978-1979">1978-1979</option> <option value="1977-1978">1977-1978</option> <option value="1976-1977">1976-1977</option> <option value="1975-1976">1975-1976</option> <option value="1974-1975">1974-1975</option> <option value="1973-1974">1973-1974</option> <option value="1972-1973">1972-1973</option> <option value="1971-1972">1971-1972</option> <option value="1970-1971">1970-1971</option>
                                       
                                </select>
                                </div> 
                                {errors.toYear && <div className="error">{errors.toYear}</div>}
                            </div> 
                            <div className="col-lg-6">
                                   <div className="form-group"> 
                                    <label className="form-label"> Last Class <span>*</span></label> 
                                    <select className="form-control" name="class" value={formData.class} onChange={handleChange} > 
                                            <option value="">- Select -</option><option value="1">I</option><option value="2">II</option>
<option value="3">III</option>
<option value="4">IV</option>
<option value="5">V</option>  <option value="6">VI</option> <option value="7">VII</option> <option value="8">VIII</option> <option value="9">IX</option> <option value="10">X</option> <option value="11">XI</option> <option value="12">XII</option> 
                                    </select> 
                                    </div>
                                    {errors.class && <div className="error">{errors.class}</div>}
                            </div>
                        </div>
                         <h6>Personal Details</h6>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="form-group">
                                <label className="form-label">Name <span>*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                /> 
                               </div>
                               {errors.name && <div className="error">{errors.name}</div>}

                            </div>
                          <div className="col-lg-6">
                              <div className="form-group">
                                <label className="form-label">Email <span>*</span></label>
                                <input
                                    type="text"
                                    name="email"
                                    className="form-control"
                                    value={formData.email}
                                    onChange={handleChange}
                                /> 
                               </div>
                               {errors.email && <div className="error">{errors.email}</div>}
                          </div> 
                          <div className="col-lg-6">
                              <div className="form-group">
                                <label className="form-label">Mobile <span>*</span></label>
                                <input
                                    type="text"
                                    name="phone"
                                    className="form-control"
                                    value={formData.phone}
                                    onChange={handleChange}
                                /> 
                            </div>
                            {errors.phone && <div className="error">{errors.phone}</div>}
                          </div>
                            <div className="col-lg-6">
                                <div className="form-group">
                                        <label className="form-label"> Location (City) <span>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="location"
                                            value={formData.location}
                                            onChange={handleChange}
                                        />
                                </div> 
                                {errors.location && <div className="error">{errors.location}</div>}
                            </div>
                            <div className="col-lg-12">
                                            <div className="form-group">
                                            <label className="form-label"> Permanent  Address <span>*</span> </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="address"
                                                value={formData.address}
                                                onChange={handleChange}
                                            />
                                        </div> 
                                        {errors.address && <div className="error">{errors.address}</div>}
                              </div>
                         </div> 
                         <h6>Education Details</h6>
                         <div className="row">
                                <div className="col-lg-6">
                                            <div className="form-group">
                                                <label className="form-label">College *</label>
                                                <input
                                                    type="text"
                                                    name="school"
                                                    className="form-control"
                                                    value={formData.school}
                                                    onChange={handleChange}
                                                /> 
                                                </div>
                                           {errors.school && <div className="error">{errors.school}</div>}  
                                    </div>
                                 <div className="col-lg-6">
                                        <div className="form-group">
                                            <label className="form-label">Degree *</label>
                                            <input
                                                type="text"
                                                name="profession3"
                                                className="form-control"
                                                value={formData.profession3}
                                                onChange={handleChange}
                                            />
                                            
                                        </div>
                                        {errors.profession3 && <div className="error">{errors.profession3}</div>}
                                    </div>
                                    <div className="col-lg-6">
                                            <div className="form-group">
                                                    <label className="form-label">Sem / Year *</label>
                                                     <input
                                                                type="text"
                                                                name="fromYear"
                                                                className="form-control"
                                                                value={formData.fromYear}
                                                                onChange={handleChange}
                                                            />
                                                            
                                            </div>
                                            {errors.fromYear && <div className="error">{errors.fromYear}</div>}
                                      </div>
                                    <div className="col-lg-6">
                                           <div className="form-group">
                                                <label className="form-label">Stream *</label>
                                                <input
                                                    type="text"
                                                    name="subject"
                                                    className="form-control"
                                                    value={formData.subject}
                                                    onChange={handleChange}
                                                />
                                                
                                            </div>
                                            {errors.subject && <div className="error">{errors.subject}</div>}
                                    </div>
                            </div>
                            <h6>Employment Details</h6>
                       <div className="row">
                                 <div className="col-lg-6">
                                    <div className="form-group">
                                        <label className="form-label"> Profession *</label>
                                        <select
                                            className="form-control"
                                            name="profession1"
                                            value={formData.profession1}
                                            onChange={handleChange}
                                        >
                                                <option value="">-Select-</option>
                                                <option value="1">Accounting</option>
                                                <option value="2">Agriculture</option>
                                                <option value="3">Architecture</option>
                                                <option value="4">Aviation</option>
                                                <option value="5">Banking</option>
                                                <option value="6">Business Services</option>
                                                <option value="7">Consulting</option>
                                                <option value="8">Education</option>
                                                <option value="9">Trading</option>
                                                <option value="10">Manufacturing</option>
                                                <option value="11">Import/ Export</option>
                                                <option value="12">Retail</option>
                                                <option value="13">Defense</option>
                                                <option value="14">Engineering</option>
                                                <option value="15">Entertainment</option>
                                                <option value="16">Fashion</option>
                                                <option value="17">Finance</option>
                                                <option value="18">Home Maker</option>
                                                <option value="19">Hospitality</option>
                                                <option value="20">IT</option>
                                                <option value="21">Law</option>
                                                <option value="22">Media</option>
                                                <option value="23">Medicine</option>
                                                <option value="24">Politics</option>
                                                <option value="25">Retired</option>
                                                <option value="26">Scientist</option>
                                                <option value="27">Service Govt. Pvt.</option>
                                                <option value="28">Social Work</option>
                                                <option value="29">Student</option>
                                                <option value="30">Travel and Tourism</option>
                                                <option value="31">Other</option>
                                        </select> 
                                      </div> 
                                      {errors.profession1 && <div className="error">{errors.profession1}</div>}
                                  </div>
                                  <div className="col-lg-6">
                                            <div className="form-group">
                                                            <label className="form-label">Organisation Name *</label>
                                                            <input
                                                                type="text"
                                                                name="school1"
                                                                className="form-control"
                                                                value={formData.school1}
                                                                onChange={handleChange}
                                                            />   
                                            </div>
                                            {errors.school1 && <div className="error">{errors.school1}</div>}
                                      </div>
                                     <div className="col-lg-6">
                                                <div className="form-group">
                                                                <label className="form-label">Designation *</label>
                                                                <input
                                                                    type="text"
                                                                    name="designation"
                                                                    className="form-control"
                                                                    value={formData.designation}
                                                                    onChange={handleChange}
                                                                />
                                                                
                                                            </div>
                                       {errors.designation && <div className="error">{errors.designation}</div>}
                                   </div>
                                     <div className="col-lg-6">
                                                <div className="form-group">
                                                                <label className="form-label">Office Address</label>
                                                                <input
                                                                    type="text"
                                                                    name="address1"
                                                                    className="form-control"
                                                                    value={formData.address1}
                                                                    onChange={handleChange}
                                                                />
                                                                
                                                            </div>
                                                            {errors.address1 && <div className="error">{errors.address1}</div>}     
                                                    </div>
                       </div>
                    </div>
                    <input type="submit" value="Submit" />
                    <div class="row"> 
                    <div className="row primarydiv"> 
                    <div className="col-lg-12 col-md-12">
                    {successMessage && <div className='primary-alert'>{successMessage}</div>} 
                    </div>
                </div>
                </div>
                </form>  
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default Alumni